module.exports = __webpack_public_path__ + "img/rulebg.7433382b.png";